export default function getUrlTokenParam() {
  let queryString = window.location.pathname;
  queryString = queryString.replace('/en/unsubscribe/', ''
  ).replace('/ru/unsubscribe/', '').slice(0, -1)

  return queryString
}

// Комментарий ради борьбы с гребаным svn-ом